import { defineMessages } from 'react-intl';

export default defineMessages({
  currency: {
    id: 'currency',
    description: 'USD',
    defaultMessage: 'USD',
  },
  addedToReview: {
    id: 'addedToReview',
    description: 'added to review',
    defaultMessage: 'Added to Review',
  },
});
